import React, { createContext, useContext, useState, useEffect } from "react";
import { API_URL } from "../utils/config";
// Create the context
const AuthContext = createContext();
const baseUrl = API_URL;
// AuthProvider component to wrap your app and provide auth state
export const AuthProvider = ({ children }) => {
  // Synchronously check for token in localStorage
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("user") // Initialize based on token presence
  );

  const [userRole, setUserRole] = useState(null);

  // Get user role from localStorage
  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const user = JSON.parse(userData);
        setUserRole(user.organizer_access || "supplier");
      } catch (error) {
        console.error("Error parsing user data:", error);
        setUserRole(null);
      }
    } else {
      setUserRole(null);
    }
  }, [isAuthenticated]);

  // Method to update state when login occurs
  const login = ( userData) => {
    // localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setIsAuthenticated(true);
    setUserRole(userData.organizer_access || "supplier");
  };
  const userLogout = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/v1/attnd/auth/logout`, {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
          lang: localStorage.getItem("language") || "en",
        },
      });

      if (!response.ok) {
        console.error("Failed to logout");
        return;
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
}
  // Method to update state on logout
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("loginDate");
    userLogout();
    setIsAuthenticated(false);
    setUserRole(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, userRole }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the auth context
export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthContext;
